
import PopupBonusReg from "components/PopupBonusReg";
import PopupLayout from "components/PopupLayout";
import React, { useState } from "react";
import './style.scss';

const BtnCuponDisabled = ( ) => {
const [showBonus, setShowBonus] = useState(false);   
const openBonus = (event, forceValue = 'none') => {
    event.preventDefault();
    setShowBonus(forceValue === 'none' ? !showBonus : (forceValue));
}


    return (
        <>
            <div className="buttons"  onClick={openBonus}>
            <a href="#" className={"btn no-hover btn-disabled"} >
            <span >Agregar cupón</span>
            </a>  
            </div>
            {
        <PopupLayout isShowwing={showBonus} showingCallback={openBonus}>
            <PopupBonusReg execActionConfirm={openBonus} />
        </PopupLayout>
        }
        </>
    );
};

export default BtnCuponDisabled;
